<template>
    <div class="paymentMethodSelector">
        <div class="row" v-if="isOptional">
            <div class="col-md-6">
                <Checkbox 
                    v-model="value.enablePlannePay"
                    label="Pagamento por PlannePay"
                    :error="false"
                    :disabled="false"
                    :required="false"
                />
            </div>
        </div>

        <div v-if="value.enablePlannePay" class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-12">
                        <label class="label">
                            Forma de pagamentos permitidas*
                        </label>
                    </div>
                </div>

                <div 
                    v-for="(paymentMethod) in paymentMethods" :key="`payment-method-${paymentMethod.id}`"
                    class="row"
                >
                    <div class="col-12">
                        <Checkbox
                            @input="() => handleInput(paymentMethod)"
                            :value="isMethodSelected(paymentMethod)"
                            :label="paymentMethod.name"
                            :error="false"
                            :disabled="false"
                            :required="false"
                        />
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div v-if="!!creditSelected" class="row">
                    <div class="col-12">
                        <Select 
                            v-model="value.maxInstallments"
                            :options="installmentsOptions(maxInstallments)"
                            label="Máximo de parcelas permitidas"
                            :error="false"
                            :disabled="false"
                            :required="false"
                        />
                    </div>
    
                    <div class="col-12">
                        <TextInput 
                            v-if="value.maxInstallments > 1"
                            v-model="value.minInstallmentValue"
                            label="Valor mínimo da parcela"
                            type="number"
                            name="minInstallmentValue"
                            min="1"
                            :error="false"
                            :disabled="false"
                            :required="false"
                        />
                    </div>
                </div>
            </div>
        </div>

        <small
            v-if="helperText"
            class="form-text"
            v-bind:class="{ 'invalid-feedback': error, 'text-muted': !error }"
        >
            {{ helperText }}
        </small>

        <!-- <hr />

        <div v-if="value.enablePlannePay" class="row">
            <div class="col-12">
                <Checkbox 
                    v-model="value.antifraud"
                    label="Desabilitar antifraude para esse pagamento"
                    :error="false"
                    :disabled="false"
                    :required="false"
                />
            </div>
        </div> -->
    </div>
</template>

<script>

import Checkbox from '../../../Checkbox';
import TextInput from '../../../TextInput';
import Select from '../../../Select';
import SellerApi from '../../../../services/SellerApi';

export default {
    components: { Checkbox, Select, TextInput },
    props: {
        appCode: String,
        value: {
            type: Object,
            required: true,
        },
        isOptional: {
            type: Boolean,
            required: false,
            default: true,
        },
        helperText: {
            type: String,
            required: false,
            default: ''
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            paymentMethodsLoading: true,
            paymentMethods: [],
            maxInstallments: 12,
            minInstallmentsValue: 1,
        };
    },
    computed: {
        creditSelected() {
            return this.value.selected.find(paymentMethod => paymentMethod.code === 'credit_card')
        },
    },
    methods: {
        installmentsOptions(maxInstallments) {
            return Array.from({length: maxInstallments}, (x, i) => i + 1);
        },
        handleInput(method) {
            const newValue = {
                ...this.value
            };

            const index = newValue.selected.findIndex(item => item.id === method.id);

            if (index !== -1) {
                newValue.selected.splice(index, 1);
            } else {
                newValue.selected.push(method);
            }

            this.$emit('input', newValue)
            this.$emit('change', newValue)
        },
        isMethodSelected(method) {
            return !!this.value.selected.find(paymentMethod => paymentMethod.id === method.id)
        },
        getPaymentMethods() {
            this.paymentMethodsLoading = true
            
            SellerApi.PaymentMethod.list(this.appCode).then((response) => {
                this.paymentMethodsLoading = false

                this.value.selected = [...response]

                this.paymentMethods = [...response]
            }).catch((error) => {
                this.paymentMethodsLoading = false

                console.error(error)
            })
        },
    },
    watch: {
    },
    mounted() {
        this.getPaymentMethods()
    },
}
</script>

<style scoped lang="scss">
.aditionalItem {
    
    .title {

    }

    .value {
        text-align: right;

    }
}
</style>
